import {uiPartCreateNamespacedParts} from "@wix/devzai-utils-common";

export const DoppeViewerActionParts = uiPartCreateNamespacedParts('DoppeViewerActionParts', {
    ActionButton: 'ActionButton',
})